import React from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import dayjs from 'dayjs';
import { Badge, Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'image',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Product',
    field: 'productName',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Qty',
    field: 'qty',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Total Cost',
    field: 'cost',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Farmer Name',
    field: 'farmerName',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Farmer Phone',
    field: 'farmerPhone',
    sort: 'asc',
    width: 270,
  },

  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Updated At',
    field: 'updatedAt',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Action',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const OrdersList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        searching={false}
        paging={false}
        data={{
          columns: columns,
          rows: props?.orders?.map((x) => ({
            farmerName: x?.farmer?.name,
            farmerPhone: x?.farmer?.phone,
            productName: x?.khareedariProduct?.name,
            qty: x?.qty,
            cost: x?.qty * x?.khareedariProduct?.price,
            status:
              x.status === 'completed' ? (
                <Badge color="success">{x.status?.toUpperCase()}</Badge>
              ) : x.status === 'cancelled' ? (
                <Badge color="danger">{x.status?.toUpperCase()}</Badge>
              ) : x.status === 'processing' ? (
                <Badge color="info">{x.status?.toUpperCase()}</Badge>
              ) : x.status === 'pending' ? (
                <Badge color="primary">{x.status?.toUpperCase()}</Badge>
              ) : (
                <></>
              ),
            image: (
              <img
                src={x?.khareedariProduct?.image}
                className="rounded-circle avatar-sm card-img"
              />
            ),

            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            updatedAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            actions: (
              <>
                <Button
                  className="mr-1 mb-1 d-block"
                  size="sm"
                  color="primary"
                  onClick={() => props.onStatusChange(x, 'pending')}
                >
                  Mark Pending
                </Button>
                <Button
                  className="mr-1 mb-1 d-block"
                  size="sm"
                  color="info"
                  onClick={() => props.onStatusChange(x, 'processing')}
                >
                  Mark Processing
                </Button>
                <Button
                  className="mr-1 mb-1 d-block"
                  size="sm"
                  color="success"
                  onClick={() => props.onStatusChange(x, 'completed')}
                >
                  Mark Complete
                </Button>
                <Button
                  size="sm"
                  color="warning"
                  onClick={() => props.onStatusChange(x, 'cancelled')}
                >
                  Cancel
                </Button>
              </>
            ),
          })),
        }}
      />
      <MDBPagination className="mb-5 justify-content-center">
        <MDBPageItem disabled={props?.currentPage === 1}>
          <MDBPageNav onClick={props?.handlePrev} className="page-link-custom">
            &laquo;
          </MDBPageNav>
        </MDBPageItem>
        {props?.renderPageNumbers}
        <MDBPageItem disabled={props?.currentPage === props?.pagesAmount}>
          <MDBPageNav onClick={props?.handleNext} className="page-link-custom">
            &raquo;
          </MDBPageNav>
        </MDBPageItem>
      </MDBPagination>
    </>
  );
};

export default OrdersList;
